import React, { useRef } from 'react';
import { LINKS } from '../data/site';
import { HeroBackground } from './HeroBackground';
import { InquiryPanel } from './InquiryPanel';
export function Hero() {
  const sectionRef = useRef<HTMLElement>(null);
  return <section ref={sectionRef} className="relative isolate overflow-hidden bg-charcoal text-cream" aria-labelledby="hero-heading" data-id="element-200" data-mp="9lbhp5hdljfp">
      <div className="relative mx-auto grid max-w-[1240px] gap-6 px-5 py-8 sm:px-8 md:grid-cols-[minmax(0,1fr)_320px] md:items-center md:gap-8 lg:grid-cols-[minmax(0,1fr)_400px] lg:items-center lg:gap-14 lg:py-8" data-id="element-201" data-mp="1297ahz3tqr77">
        <div className="max-w-[560px]" data-id="element-202" data-mp="sai4p4p7cx7b">
          <h1 id="hero-heading" className="font-display text-[42px] font-bold uppercase leading-[0.95] tracking-[-0.01em] text-white sm:text-[56px] md:text-[48px] lg:text-[68px]" data-id="element-203" data-mp="s9gh60r02i8p">
            Metal shaping tools.
            <br data-id="element-204" data-mp="381xn73sg3cct" />
            <span className="text-fred" data-id="element-205" data-mp="381e25e7i07uk"><span className="whitespace-nowrap" data-id="element-206" data-mp="3814bdoempwnt">Hands-on</span>{' '}<span className="whitespace-nowrap" data-id="element-207" data-mp="3j7zhlpe3m4ju">know-how.</span></span>
          </h1>
          <p className="mt-5 max-w-[48ch] text-[16px] leading-relaxed text-steel-200 sm:text-[17px]" data-id="element-208" data-mp="3o7c1q2dl4xiq">
            Equip your shop, learn at the workbench, or bring a custom metalwork project to life. Get tools,
            training and practical guidance from the Fournier shop.
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-209" data-mp="30i19j9aawbg7">
            <a href={LINKS.shopAll} className="inline-flex min-h-[52px] items-center bg-fred px-5 font-display text-[18px] sm:px-7 sm:text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-210" data-mp="30gq5r9guv3p3">
              Shop Metalworking Tools
            </a>
            <a href={LINKS.workshops} className="inline-flex min-h-[52px] items-center px-2 font-display text-[20px] uppercase tracking-[0.06em] text-white underline decoration-white/30 underline-offset-8 transition-colors duration-150 ease-out hover:decoration-fred" data-id="element-211" data-mp="2hjf3dfzxfu5f">
              Explore Workshops
            </a>
          </div>
        </div>

        <InquiryPanel data-id="element-212" data-mp="ic88ngd628yd" />
      </div>

      <HeroBackground sectionRef={sectionRef} data-id="element-213" data-mp="id9v0gzmuhve" />
    </section>;
}